import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { firebaseAuth } from '@/firebase/firebaseAuth'
import { onAuthStateChanged } from 'firebase/auth'

Vue.use(Vuex)

const state = {
  key: '',
  title: '',
  content: '',
  date: null,
  imgUrl: '',
  youtube: '',
  lat: '',
  lng: '',
  user: null
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

onAuthStateChanged(firebaseAuth, (user) => {
  if (user) {
    store.commit('setUser', user)
  } else {
    store.commit('setUser', null)
  }
})

export default store
